import React, { useEffect } from 'react';
import classnames from 'classnames';
import { textUtils } from '@instinet-analytics/core-lib';
import { useDelayedHover } from '@instinet-analytics/core-lib';
import './RevisionNumber.scss';

const { getOrdinalText } = textUtils;

interface RevisionNumberProps {
    valIndex: number;
    listIndex: number;
    setIndex: (index: number) => void;
    showLabel?: boolean;
    onIsHoveringChanged?: (nextIsHovering: boolean) => void;
}

export default function RevisionNumber(props: RevisionNumberProps) {
    const { valIndex, listIndex, setIndex, showLabel, onIsHoveringChanged } =
        props;

    const selected = valIndex === listIndex;
    const [onMouseEnter, onMouseLeave, isHovering] = useDelayedHover(0);

    useEffect(() => {
        if (onIsHoveringChanged) {
            onIsHoveringChanged(isHovering);
        }
    }, [isHovering, onIsHoveringChanged]);

    return (
        <div
            className={classnames('RevisionNumber', selected && 'selected')}
            onClick={() => !selected && setIndex(valIndex)}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            {showLabel && isHovering ? getLabelText(valIndex) : valIndex}
        </div>
    );
}

function getLabelText(index: number) {
    return index === 0 ? 'Original Order' : getOrdinalText(index) + ' Revision';
}
